module.exports = __webpack_public_path__ + "static/11-7cb4af00a0892115e6cfa861a0786058.jpeg";